import classNames from "classnames";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

import { TrackerA } from "@/components/Tracker";
import { EVENT } from "@/constants/event";
import { PIN_APPEAL_STATUS } from "@/constants/pin";
import { deletePin, fileAppeal } from "@/services";
import { useMemoizedFn, useUpdate } from "ahooks";
import { Dropdown } from "antd";
import { CSSProperties, useMemo, type ReactNode } from "react";
import HBMessage from "../HBMessage";
interface IProps {
  iconSize?: number;
  text?: ReactNode;
  className?: string;
  hideText?: boolean;
}
/**违规内容 */
export function Violation({
  iconSize = 32,
  className,
  text = "内容涉嫌违规",
  hideText = false,
  ...rest
}: IProps & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={classNames(className, styles.violation)} {...rest}>
      <HBIcon type="ic_alert" style={{ fontSize: iconSize }} />
      {!hideText && <div className={styles.text}>{text}</div>}
    </div>
  );
}

export function ViolationPinCard({
  pin,
  style = {},
}: {
  pin: IPin;
  style?: CSSProperties;
}) {
  const update = useUpdate();

  const onDelete = useMemoizedFn(async () => {
    // 删除采集
    const res = await deletePin({ pin_id: pin.pin_id });
    if (!res.err) {
      HBMessage.success("删除成功");
      window.dispatchEvent(
        new CustomEvent(EVENT.DELETE_PIN, { detail: pin.pin_id })
      );
    }
  });

  const onAppeal = useMemoizedFn(async () => {
    const res = await fileAppeal(pin.pin_id);
    if (!res.err) {
      HBMessage.success("已发起申诉，待审核");
      pin.file_appeal = { status: PIN_APPEAL_STATUS.APPEALING };
      update();
    }
  });

  const text = useMemo(() => {
    switch (pin?.file_appeal?.status) {
      case PIN_APPEAL_STATUS.APPEALING:
        return "已发起申诉, 审核中~";
      case PIN_APPEAL_STATUS.REJECT:
        return (
          <>
            申诉失败, 内容违规
            <br />
            如有疑问请联系在线客服
          </>
        );
      default:
        return "内容涉嫌违规";
    }
  }, [pin?.file_appeal?.status]);

  const moreMenu = useMemo(() => {
    return (
      <div className={styles.menu}>
        {!pin.file_appeal && (
          <TrackerA
            className={styles.menuItem}
            onClick={onAppeal}
            data-gd-click="button_click"
            data-button-name="我要申诉"
            data-report-type="采集"
            data-report-pin-id={pin?.pin_id}
            data-report-file-id={pin?.file_id}
            data-report-content-id={pin?.file_material?.material_id}
          >
            <span className={styles.text}>我要申诉</span>
          </TrackerA>
        )}
        <TrackerA
          className={styles.menuItem}
          onClick={onDelete}
          data-gd-click="button_click"
          data-button-name="删除采集"
          data-report-type="采集"
          data-report-pin-id={pin?.pin_id}
          data-report-file-id={pin?.file_id}
          data-report-content-id={pin?.file_material?.material_id}
        >
          <span className={styles.text}>删除采集</span>
        </TrackerA>
      </div>
    );
  }, [onDelete, onAppeal, pin]);

  return (
    <div className={styles.card} style={style}>
      <Violation text={text} />
      <Dropdown overlay={moreMenu} placement="bottomLeft" trigger={["click"]}>
        <div className={styles.more} title="更多操作">
          <HBIcon className={styles.icon} type="ic_more" />
        </div>
      </Dropdown>
    </div>
  );
}
